import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CONTEXT_MENU_WIDTH } from '../ContextMenu.styles'

export const ItemIcon = styled(FontAwesomeIcon)`
  margin: ${props => props.theme.dropdown.item.iconMargin};
`

export const Label = styled.div`
  text-align: left;
  color: ${props => props.color};
`

export const TextSection = styled.div`
  display: flex;
  flex: 1;
`

export const Description = styled.div`
  align-self: flex-end;

  color: ${props => props.theme.dropdown.item.description.color};
  font-size: ${props => props.theme.dropdown.item.description.fontSize};
  margin: ${props => props.theme.dropdown.item.description.margin};
`

export const ItemWrapper = styled.div<{ $isActive?: boolean; $leaveSpaceForSubmenu?: boolean }>`
  display: flex;
  font-size: ${props => props.theme.dropdown.item.fontSize};
  padding: ${props => props.theme.dropdown.item.padding};
  ${props => props.$leaveSpaceForSubmenu && `padding-right: calc(${CONTEXT_MENU_WIDTH} + 3px);`};

  position: relative;

  &:hover {
    background-color: ${props => props.theme.dropdown.item.activeBgColor};
    cursor: pointer;
  }

  ${props => {
    if (props.$isActive) {
      return `background-color: ${props.theme.dropdown.item.activeBgColor};`
    }
  }}
`

export const SvgIconWrapper = styled.div`
  width: 30px;
  display: flex;
  margin-left: -10px;
  justify-content: center;

  align-items: center;

  svg {
    margin: 0;
  }
`
